import { type AngelouCSS } from "@newsela/angelou";

export const toggleButtonCss: AngelouCSS = {
  display: "flex",
  gap: "16px",
  padding: 0,
};

export const toggleLabelCss: AngelouCSS = {
  textAlign: "left",
};
